import type { FormEvent } from 'react'

/**
 * Envía un formulario sin que React lo vacíe.
 *
 * Con `<form action={fn}>`, React 19 resetea el formulario al terminar la
 * acción, aunque la validación la haya detenido o el servidor haya respondido
 * con un error: cada campo no controlado vuelve a su valor inicial y el usuario
 * pierde lo que escribió. Pasó al crear un cliente: faltaba contestar el
 * permiso de WhatsApp y se borraba el nombre.
 *
 *   <form onSubmit={(e) => enviarSinVaciar(e, onSubmit)}>
 *
 * Siempre DENTRO de la flecha: pasarle `onSubmit` durante el render lo marca
 * `react-hooks/refs` cuando esa función lee una ref.
 *
 * `onSubmit` sigue recibiendo el FormData, igual que con `action`, y además el
 * formulario: el que se queda abierto después de guardar (agregar otra mesa,
 * otro producto) lo limpia con `formulario.reset()` SOLO cuando guardó bien.
 * Ambos se toman en el momento del evento: dentro de una función async
 * `e.currentTarget` ya no existe.
 */
export function enviarSinVaciar(
  e: FormEvent<HTMLFormElement>,
  enviar: (datos: FormData, formulario: HTMLFormElement) => void,
): void {
  e.preventDefault()
  const formulario = e.currentTarget
  enviar(new FormData(formulario), formulario)
}
